<mat-form-field subscriptSizing="dynamic">
    <mat-label *ngIf="label()">
        {{ label() }}
    </mat-label>

    <input
        #control
        matInput
        [disabled]="disabled()"
        [ngModel]="internalValue()"
        [class.st-text-field__input--edit]="!inEditMode"
        [placeholder]="label() || placeholder()"
        [required]="required()"
        [maxLength]="maxLength()"
        [type]="type()"
        (change)="onValueChanged()"
        (ngModelChange)="onNgModelChanged($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keyup)="keyPressed($event)" />
    <mat-hint *ngIf="hint()"> {{ hint() }} </mat-hint>
    <ng-container
        *ngIf="hasSuffix()"
        matSuffix>
        <ng-content select="[suffix]" />
    </ng-container>
    <ng-container
        *ngIf="hasPrefix()"
        matPrefix>
        <ng-content select="[prefix]" />
    </ng-container>
    <ng-container
        *ngIf="hasError()"
        matError>
        <ng-content select="[error]" />
    </ng-container>
</mat-form-field>
